import { IActionOptions } from '@interfaces/IActionOptions';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IMaterial } from '@interfaces/IMaterial';
import { Action } from '@ngrx/store';

export enum EMaterialsActions {
  AddMaterial = '[Materials] Add Material',
  AddMaterialSuccess = '[Materials] Add Material Success',
  AddMaterialFailure = '[Materials] Add Material Failure',

  UpdateMaterial = '[Materials] Update Material',
  UpdateMaterialSuccess = '[Materials] Update Material Success',
  UpdateMaterialFailure = '[Materials] Update Material Failure',

  GetMaterial = '[Materials] Get Material',
  GetMaterialSuccess = '[Materials] Get Material Success',

  GetMaterials = '[Materials] Get Materials',
  GetMaterialsSuccess = '[Materials] Get Materials Success',
  ClearMaterials = '[Materials] Clear Materials',

  DeleteMaterial = '[Materials] Delete Material',
  DeleteMaterialSuccess = '[Materials] Delete Material Success',
  DeleteMaterialFailure = '[Materials] Delete Material Failure ',
  ClearDeleteMaterialErrors = '[Materials] Clear Delete Material Errors',
}

export class AddMaterial implements Action {
  public readonly type = EMaterialsActions.AddMaterial;

  constructor(public material: FormData, public options?: IActionOptions) {}
}

export class AddMaterialSuccess implements Action {
  public readonly type = EMaterialsActions.AddMaterialSuccess;

  constructor(public material: IMaterial) {}
}

export class AddMaterialFailure implements Action {
  public readonly type = EMaterialsActions.AddMaterialFailure;

  constructor(public errors: IFormErrors) {}
}

export class GetMaterials implements Action {
  public readonly type = EMaterialsActions.GetMaterials;

  constructor(
    public group_id?: number | null,
    public options?: IActionOptions
  ) {}
}

export class GetMaterialsSuccess implements Action {
  public readonly type = EMaterialsActions.GetMaterialsSuccess;

  constructor(public data: { count: number; results: IMaterial[] }) {}
}

export class ClearMaterials implements Action {
  public readonly type = EMaterialsActions.ClearMaterials;
}

export class GetMaterial implements Action {
  public readonly type = EMaterialsActions.GetMaterial;

  constructor(public id: number) {}
}

export class GetMaterialSuccess implements Action {
  public readonly type = EMaterialsActions.GetMaterialSuccess;

  constructor(public material: IMaterial) {}
}

export class UpdateMaterial implements Action {
  public readonly type = EMaterialsActions.UpdateMaterial;

  constructor(public material: { content: string; title: string }) {}
}

export class UpdateMaterialSuccess implements Action {
  public readonly type = EMaterialsActions.UpdateMaterialSuccess;
}

export class UpdateMaterialFailure implements Action {
  public readonly type = EMaterialsActions.UpdateMaterialFailure;
}

export class DeleteMaterial implements Action {
  public readonly type = EMaterialsActions.DeleteMaterial;

  constructor(public material_id: number) {}
}

export class DeleteMaterialSuccess implements Action {
  public readonly type = EMaterialsActions.DeleteMaterialSuccess;

  constructor(public material_id: number) {}
}

export class DeleteMaterialFailure implements Action {
  public readonly type = EMaterialsActions.DeleteMaterialFailure;
}

export class ClearDeleteMaterialErrors implements Action {
  public readonly type = EMaterialsActions.ClearDeleteMaterialErrors;
}

export type MaterialsActions =
  | AddMaterialSuccess
  | AddMaterialFailure
  | AddMaterial
  | GetMaterialSuccess
  | GetMaterialsSuccess
  | UpdateMaterial
  | UpdateMaterialSuccess
  | UpdateMaterialFailure
  | GetMaterial
  | GetMaterials
  | DeleteMaterial
  | DeleteMaterialFailure
  | DeleteMaterialSuccess
  | ClearMaterials
  | ClearDeleteMaterialErrors;
